export function buildLeadSubmissionPayload({
  request,
  leadId = null,
  customerId = null,
  directBusinessId = null,
  mediaRows = [],
}) {
  const form = request.form || {};
  const rawFormJson = { ...form };
  delete rawFormJson.uploadedPhotos;

  return {
    lead: {
      id: leadId,
      customer_name: request.customer,
      customer_phone: form.phone,
      customer_email: form.email,
      address: [
        form.address,
        form.suburb,
        form.state,
        form.postcode,
      ].filter(Boolean).join(", "),
      suburb: request.suburb,
      postcode: form.postcode || "",
      trade: request.trade,
      project_type: request.type,
      property_type: form.propertyType,
      scope_summary: request.areas,
      condition: request.complexity,
      urgency: form.urgency,
      status: "New",
      lead_quality_score: request.score,
      customer_user_id: customerId,
      direct_business_id: directBusinessId,
      estimate_low: request.estimate?.low || null,
      estimate_high: request.estimate?.high || null,
    },
    details: {
      areas: form.areas,
      measurements: form.measurements,
      access_details: form.accessDetails,
      issue_type: form.issueType,
      service_category: form.serviceCategory,
      notes: form.notes,
      raw_form_json: rawFormJson,
    },
    media: mediaRows,
  };
}

export function buildSavedLeadRequest({
  request,
  leadId,
  maxLeadBuyers = 3,
}) {
  return {
    ...request,
    id: leadId,
    status: "New",
    soldCount: 0,
    remainingSlots: maxLeadBuyers,
    soldOut: false,
    lastUpdated: "Saved to Supabase",
    detailsLoaded: true,
  };
}
